import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class LoadingService {

    private readonly _defaultMessages: string = "Patientez durant le chargement de l'application";
    private loaderSubject = new Subject<LoaderState>();
    loaderState = this.loaderSubject.asObservable();

    //Code spécifique pour la gestion des loaders par code unique
    private _actifsCode:string[] = [];

    constructor() { }

    /**
     * Visualise le loader avec un message sinon defaut
     * @param msg message affiché dans le loader sinon message defaut :"Patientez durant le chargement de l'application"
     */
    show(msg: string = this._defaultMessages) {
        this.loaderSubject.next(<LoaderState>{ show: true, msg: msg });
    }

    hide() {
        this.loaderSubject.next(<LoaderState>{ show: false });
    }

    /**
     * Visualise le loader avec un message sinon defaut
     * @param msg message affiché dans le loader sinon message defaut :"Patientez durant le chargement de l'application"
     * @param uniqueCode code unique permettant de gérer l'affichage du loader par code
     */
    showByCode(msg: string = this._defaultMessages,uniqueCode:string) {
        if(uniqueCode && !this._actifsCode.includes(uniqueCode)){
            this._actifsCode.push(uniqueCode);
        }
        this.loaderSubject.next(<LoaderState>{ show: true, msg: msg });
    }


    /**
     * Ferme le loader si aucun code unique n'est actif.
     * @param uniqueCode code unique permettant de gérer la fermeture du loader par code
     */
    hideByCode(uniqueCode:string) {
        if(uniqueCode && this._actifsCode.includes(uniqueCode)){
            this._actifsCode = this._actifsCode.filter(code => code !== uniqueCode);
        }
        if(this._actifsCode.length === 0){
            this.loaderSubject.next(<LoaderState>{ show: false });
        }   
    }

    /**
     * Supprime tous les codes actifs et ferme le loader.
     */
    clearAllCodes() {
        this._actifsCode = [];
        this.loaderSubject.next(<LoaderState>{ show: false });
    }

    /**
     * Ajout des codes de chargement actifs pour le loader
     * @param uniqueCodes tableau des codes uniques à ajouter
     */
    addCodes(uniqueCodes:string[]) {
        uniqueCodes.forEach(uniqueCode => {
            if(uniqueCode && !this._actifsCode.includes(uniqueCode)){
                this._actifsCode.push(uniqueCode);
            }
        });
    }
}

export interface LoaderState {
    show: boolean;
    msg: string;
}
